import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TranslateLoader } from '@ngx-translate/core';
import Env from '@ridango/core/env';

@Injectable()
export class TranslationsService implements TranslateLoader {
    constructor(
        private http: HttpClient,
        @Inject('ENV') public env: Env
    ) {}

    getTranslation(lang: string): Observable<{ [key: string]: string }> {
        if (this.env.WMB?.TRANSLATION_PROVIDER) {
            return this.http.get<{ [key: string]: string }>(`${this.env.WMB.WMB_PUBLIC_API}/v1/translations/${lang}`);
        }
        return this.http.get<{ [key: string]: string }>(
            `${this.env.API_BASE_URL}/${this.env.TRANSLATIONS_ID}/translations/get/${lang}.json`
        );
    }
}
